// ##### 23-12-27 Komarov
import parse from 'html-react-parser';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../Redux/selectors';
// ##### 25-04-18 Komarov
import { getLoadedPage } from '../../../Redux/actions';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../server/helpers/uniLog';
// ##### 25-05-20 Komarov
import uniqueId from 'lodash.uniqueid';

// ##### 23-09-14 Komarov
// import './TermsConditionsCSS.css'

// ##### Komarov 2025-07-14
const TermsConditions = ({ readTerms, closeTermsConditions }) => {
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  const dispatch = useDispatch();
  // ##### 25-04-23 Komarov
  const deviceType = useSelector(selectDeviceType);

  // ##### 25-04-18 Komarov
  const loadedpages = useSelector(state => state.pages.loadedpages);
  // ##### Komarov 2025-07-28
  const purePage = loadedpages['19']?.[locale];

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      "axios:src/Components/Pages/BookingForm/TermsConditions.js:getPurePage('19',locale)"
    );
    // ##### Komarov 2025-07-28
    if (!purePage) {
      dispatch(
        getLoadedPage({
          spid: 19,
          lang: locale,
          deviceType,
        })
      );
    }
    // ##### 23-04-12 Komarov
  }, [dispatch, locale]);

  // console.log('[PURE_PAGE]', purePage)

  if (!purePage) {
    return <div> Loading...</div>;
  }

  return (
    <div
      data-component="TermsConditions"
      className={`${readTerms === false ? 'TermsNotVisible' : 'TermsVisible'}`}
      // ##### 25-05-20 Komarov
      // style={{
      //   maxWidth: width,
      //   maxHeight: height / 2,
      // }}
      style={{
        width: '100%',
        height: '100%',
        left: 0,
      }}
    >
      {
        // ##### 25-05-20 Komarov
        purePage?.map(page => {
          if (page.content_name === 'Body') {
            return (
              <React.Fragment key={uniqueId()}>
                <div
                  style={{
                    fontSize: 'xx-large',
                    color: '#005aeb',
                    cursor: 'pointer',
                    position: 'fixed',
                    top: '8px',
                    right: '23px',
                    zIndex: 1000,
                    backgroundColor: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                  onClick={closeTermsConditions}
                  onKeyDown={e => {
                    // Trigger click action on Enter key press
                    if (e.key === 'Enter') {
                      closeTermsConditions();
                    }
                  }}
                >
                  {/* ##### 24-08-16 Komarov */}
                  &times;
                </div>
                <div>{parse(page.text)}</div>
              </React.Fragment>
            );
          }
        })
      }
    </div>
  );
};

export default TermsConditions;
